import type { FC } from 'react';
import { colors } from 'styles/colors';

type Props = { className?: string; bgColor?: string; checkedColor?: string };

export const CheckBoxIcon: FC<Props> = ({ bgColor = colors.primary, checkedColor = colors.white, className }) => {
  return (
    <svg
      className={className}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10401_219636)">
        <path
          d="M27 0H3C1.34315 0 0 1.34315 0 3V27C0 28.6569 1.34315 30 3 30H27C28.6569 30 30 28.6569 30 27V3C30 1.34315 28.6569 0 27 0Z"
          fill={bgColor}
        />
        <path d="M7.13379 14.688L13.3888 20.943" stroke="white" strokeWidth="2" strokeLinecap="round" />
        <path d="M25.134 9.37109L13.875 20.9421" stroke="white" strokeWidth="2" strokeLinecap="round" />
      </g>
      <defs>
        <clipPath id="clip0_10401_219636">
          <rect width="30" height="30" fill={checkedColor} />
        </clipPath>
      </defs>
    </svg>
  );
};
